const brands = [
  {id: "1", name: "Network admin", url: "keystone-help.timeincuk.net"},
  {id: "3", name: "The Field", url: "www.thefield.co.uk"},
  {id: "7", name: "Rugby World", url: "www.rugbyworld.com"},
  {id: "8", name: "Country Life", url: "www.countrylife.co.uk"},
  {id: "11", name: "MBR", url: "www.mbr.co.uk"},
  {id: "14", name: "Horse and Hound", url: "www.horseandhound.co.uk"},
  {id: "18", name: "MBY", url: "www.mby.com"},
  {id: "19", name: "PBO", url: "www.pbo.co.uk"},
  {id: "20", name: "Yachting Monthly", url: "www.yachtingmonthly.com"},
  {id: "21", name: "Yachting World", url: "www.yachtingworld.com"},
  {id: "22", name: "YBW", url: "www.ybw.com"},
  {id: "34", name: "Decanter", url: "www.decanter.com"}
];

export default brands;
